import { EvidenceType, VerifiableCredential } from '../../common/types';

export enum ScopeRequestStatus {
  // The scope request has just been created and is waiting for the user to acknowledge it
  AWAITING_USER = 'awaiting-user',
  // The user has acknowledged the scope request and is working on resolving it
  USER_ACKNOWLEDGED = 'user-acknowledged',
  // The user cannot resolve the scope request or chooses not to, and has cancelled it
  USER_CANCELLED = 'user-cancelled',
  // SIP has verified that the user has resolved each of the components (identity & payment) successfully
  VERIFICATION_SUCCESS = 'verification-success',
  // The user has failed to resolve at least one of the components
  VERIFICATION_FAILED = 'verification-failed',
}

export type ScopeRequest = {
  links: { href: string; rel: string }[];
  uuid: string;
  access?: { imageUri: string };
  status: ScopeRequestStatus;
  created?: number;
  timeout?: number;
  expires?: number;
  updated?: number;
  components: ScopeRequestComponents;
  reason?: string;
};

export interface ScopeRequestComponents {
  identity: IdentityComponent;
  compliance: ComplianceComponent;
}

export interface ComplianceComponent {
  request: ComplianceComponentRequest;
}

export interface IdentityComponent {
  request?: IdentityComponentRequest;
  response?: VerifiableCredential[];
  result?: IdentityComponentResult;
}

export interface EvidenceChannel {
  accepts: string;
  method: 'put' | string;
  url: string;
}

export type EvidenceChannels = Record<EvidenceType, EvidenceChannel>;

export interface Channels {
  evidences: EvidenceChannels;
}

export type IsCondition = { $eq: string } | { $in: string[] } | { $nin?: string[] } | { $lte?: string };

export interface Claim {
  path: string;
  is: IsCondition;
}

export interface Constraints {
  claims: Claim[];
}

export interface CredentialItem {
  identifier: string;
  credential: string;
  constraints: Constraints;
}

export interface IdentityComponentRequest {
  payload: {
    channels: Channels;
    credentialItems: CredentialItem[];
  };
}

export interface IdentityComponentResult {
  status: string;
  reason?: string;
}

export interface ComplianceComponentRequest {
  termsAndConditions: string;
  declarationText: string;
}

export enum QrCodeTheme {
  DEFAULT = 'default',
  BLUE = 'blue',
}
